<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <form action v-on:submit.prevent="createQuestionary">
        <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <header class="modal-card-head">
            <p class="modal-card-title">Crear Encuesta</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Nombre">
              <b-input
                type="text"
                :value="questionarie.name"
                v-model="questionarie.name"
                placeholder="Nombre"
                required
              ></b-input>
            </b-field>
            <b-field label="Descripcion">
              <b-input
                type="input"
                :value="questionarie.description"
                v-model="questionarie.description"
                placeholder="Descripcion"
                required
              ></b-input>
            </b-field>
            <b-field grouped>
              <b-field label="Fecha de Inicio">
                <b-input
                  type="date"
                  :value="questionarie.date_start"
                  v-model="questionarie.date_start"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
              <b-field label="Fecha de Término">
                <b-input
                  type="date"
                  :value="questionarie.date_end"
                  v-model="questionarie.date_end"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
              <b-field label="¿Mostrar Resultados?">
                <b-select v-model="questionarie.show_results">
                  <option :value="false">No</option>
                  <option :value="true">Si</option>
                </b-select>
              </b-field>
            
            </b-field>
              
            <b-field grouped>
              <b-field label="¿Termino de Condiciones?">
                <b-select v-model="questionarie.term_required">
                  <option :value="false">No</option>
                  <option :value="true">Si</option>
                </b-select>
              </b-field>
              <b-field label="Seleccionar Termino de Condición" v-if="questionarie.term_required">
                <b-select
                  placeholder="Seleccionar el Termino de Condición"
                  v-model="questionarie.term_id"
                  expanded
                >
                  <option v-for="term in listTerms" :value="term.id" :key="term.id">{{ term.title }}</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field label="Seleccionar Locación">
              <b-taginput
                v-model="locationSelected"
                :data="filteredTags"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="name"
                placeholder="Seleccionar"
                @input="filteredTags = listLocation"
                @typing="getFilteredTags"
              ></b-taginput>
            </b-field>
            <b-field label="Seleccionar Estamento" >
              <b-taginput  
                v-model="estamentSelected"
                :data="filteredStament"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="name"
                placeholder="Seleccionar"
                @input="filteredStament = listEstament"
                @typing="getFilteredTags"
              ></b-taginput>
            </b-field>
            <br />
            <br />
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeBasic()">Cerrar</button>
            <button class="button is-primary" type="submit">Guardar</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>
<script>
import { storeQuestionarie } from "../../../services/questionarie";
import { storeQuestionLocation } from "../../../services/question_location";
import { getLocations } from "../../../services/location";
import { getTerms } from "../../../services/terms";
import { getStament } from "../../../services/stament";
import { storeEstamentRestrict } from "../../../services/restriction";


export default {
  props: ["isComponentModalActive", "closeBasic", "chargeQuestionarieList"],
  data() {
    return {
      questionarie: {
        name: "",
        description: "",
        date_start: "",
        date_end: "",
        state: "",
        term_id: 1,
        term_required: false,
        show_results: false,
        restriction: true,
      },
      listLocation: [],
      filteredTags: [],
      locationSelected: [],
      filteredStament: [],
      listEstament:[],
      estamentSelected:[],
      listTerms: [],
      isLoading: false,
    };
  },
  created: function () {
    this.isLoading = true;
    this.showTerms();
    this.showLocation().then((this.isLoading = false));
  },
  methods: {
    async createQuestionary() {
      this.isLoading = true;
      let data = {
        ...this.questionarie,
        term_id: this.questionarie.term_required == 0 ? 1 : this.questionarie.term_id,
        user_id: JSON.parse(window.localStorage.getItem("user")).id,
        state: "Creada",
      };
      await storeQuestionarie(this.$http, data).then(async (response) => {
        let idQuestionary = response.id;
        let promises = [];
        this.locationSelected.forEach(async (element) => {
          let data = {
            questionary_id: idQuestionary,
            location_id: element.id,
          };
          promises.push(
            new Promise((resolve, reject) => {
              storeQuestionLocation(this.$http, data)
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject();
                });
            })
          );
         
        });

        this.estamentSelected.forEach(async (element)=>{
            let dato = {
            questionary_id: idQuestionary,
            stament_id: element.id,
          };
           promises.push(
            new Promise((resolve, reject) => {
              storeEstamentRestrict(this.$http, dato)
                .then(() => {
                  resolve();
                })
                .catch(() => {
                  reject();
                });
            })
          );
        })
        Promise.all(promises).then(() => {
          this.isLoading = false;
          this.toast("Encuesta Creada", "is-success");
          this.chargeQuestionarieList();
          this.closeBasic();
        });
      });
    },
    async showLocation() {
      await getLocations(this.$http).then((response) => {
        this.listLocation = response;
        this.filteredTags = response;
      });
      await getStament(this.$http).then((response) => {
        this.listEstament = response;
        this.filteredStament = response;
      });
    },
    getFilteredTags(text) {
      this.filteredTags = this.listLocation.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
     getFilteredStament(text) {
      this.filteredStament = this.listEstament.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    async showTerms() {
      await getTerms(this.$http).then((response) => {
        this.listTerms = response;
      });
    },
  },
};
</script>